var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm.addresses.length
        ? _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.addresses, function(address) {
              return _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "card bg-light mb-2" }, [
                  _c("div", { staticClass: "card-body p-3" }, [
                    address.is_invoice
                      ? _c("h5", { staticClass: "card-title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("pages.account.address.label_invoice")
                              ) +
                              "\n                        "
                          )
                        ])
                      : address.is_delivery
                      ? _c("h5", { staticClass: "card-title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("pages.account.address.label_delivery")
                              ) +
                              "\n                        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("p", { staticClass: "pb-0" }, [
                      _c("strong", [_vm._v(_vm._s(address.full_name))]),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(address.address_one)
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(address.address_two)
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(address.postal_code) +
                          " " +
                          _vm._s(address.city)
                      ),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(address.country_name) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-outline-dark",
                            attrs: {
                              tag: "a",
                              to: {
                                name: "account.address.edit",
                                params: {
                                  type: address.is_invoice
                                    ? "invoice"
                                    : "delivery"
                                }
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "mdi mdi-pencil" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("actions.edit")) +
                                "\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            }),
            0
          )
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "alert alert-secondary border-dark shadow-sm" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("pages.account.address.none")) +
                      "\n                "
                  )
                ]
              )
            ])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }